import React from "react";
import { AnchorLink, SectionHeading, Wrapper } from "@gw/component-library";
import { BaseLayout } from "../../layouts";
import { UserProfile } from "../../components";
import { UserProfilePageStyled } from "./UserProfilePageStyled";
var UserProfilePage = function () {
    return (React.createElement(BaseLayout, null,
        React.createElement(UserProfilePageStyled, null,
            React.createElement(Wrapper, { className: "wrapper my-50" },
                React.createElement(AnchorLink, { to: "/directory" }, "\u2190 Back to Homepage"),
                React.createElement(SectionHeading, { className: "heading" }, "My Profile"),
                React.createElement(UserProfile, null)))));
};
export default UserProfilePage;
//# sourceMappingURL=UserProfilePage.js.map